import { useToggleTodayFilterTag } from 'features/user';
import React, { useMemo } from 'react';
import { SelectTagsContextMenu } from 'shared/components/connected/select-tags-context-menu';
import { useUser } from 'shared/hooks/use-user';

export type FilterContextMenuProps = Omit<
  React.ComponentProps<typeof SelectTagsContextMenu>,
  'activeTags' | 'onTag'
>;

export const FilterContextMenu: React.FC<FilterContextMenuProps> = ({
  ...selectTagsContextMenuProps
}) => {
  const user = useUser();

  const toggleTodayFilter = useToggleTodayFilterTag();

  const activeTags = useMemo(
    () => user?.settings?.todayFilterByTags ?? [],
    [user?.settings?.todayFilterByTags],
  );

  return (
    <SelectTagsContextMenu
      {...selectTagsContextMenuProps}
      onTag={toggleTodayFilter}
      activeTags={activeTags}
    />
  );
};
